/**
 * useIssuesSegment — aktives Arbeitspaket + damit gepackte Zeilen (P2b/B8).
 * Paket wirkt VOR useIssuesFilters (Facetten/Suche/Sort greifen danach).
 * selectedId (useProductSegments, geteilter localStorage-Key mit /v2/products)
 * ist die EINE Quelle — kein eigener Rule-State, sonst driftet die Tabelle bei
 * einer bereits persistierten Auswahl vom aktiv markierten Chip auseinander.
 */
import { useMemo } from 'react'
import { useProductSegments } from './useProductSegments'
import { evaluateSegment } from '@/components/v2/products/segments/segmentEvaluator'
import type { Channel } from '@/lib/api/channels'
import type { ProductWithIssues } from '@/lib/api/channel-readiness'

export function useIssuesSegment(products: ProductWithIssues[], channels: Channel[]) {
  const { selectedId, customSegments, select, addSegment } = useProductSegments()
  const active = customSegments.find((s) => s.id === selectedId)

  const packaged = useMemo(
    () => (active ? evaluateSegment(active.rule, products, channels) : products),
    [active, products, channels],
  )

  return { selectedId, customSegments, select, addSegment, packaged }
}
